module.exports = __webpack_public_path__ + "static/pic09-d59e4b49832baeb9c62a7a9d6c070f8c.jpg";